import PageHeader from 'components/pageHeader/PageHeader';
import useSidePanel from 'components/sidePanel/useSidePanel';
import { integrationsTabSidePanelId } from 'pages/integrations/IntegrationsTabs.constants';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import useIsMobileScreen from 'hooks/useIsMobileScreen';
import { MenuButtonStyled, TabHeaderTitleStyled } from './TabHeader.styles';

const INTEGRATIONS_DOC_LINK =
  'https://help.hostfully.com/en/collections/113516-integrations';

const TabHeader = ({ tabName }: { tabName: string }) => {
  const isMobile = useIsMobileScreen();
  const { triggerClassName, toggleSidePanel } = useSidePanel({
    sidePanelId: integrationsTabSidePanelId,
  });

  return (
    <div>
      <PageHeader
        title={
          <>
            {isMobile && (
              <MenuButtonStyled
                data-testid="settings-tab-hamburger-menu"
                onClick={toggleSidePanel}
                className={triggerClassName}
                bsStyle="default"
              >
                <Glyphicon glyph="menu-hamburger" />
              </MenuButtonStyled>
            )}

            <Trans
              i18nKey="pageIntegrations.header.title"
              components={{
                green: <TabHeaderTitleStyled />,
              }}
              values={{
                tabName,
              }}
            />
          </>
        }
        subtitle={
          <Trans
            i18nKey="pageIntegrations.header.description"
            components={{
              1: <Link to={INTEGRATIONS_DOC_LINK} target="_blank" />,
            }}
          />
        }
      />
    </div>
  );
};

export default TabHeader;
